import { type DocObj, type FormattedValue } from "@hsl/fund-explorer/types";

export function mergeDocs(
    doc1?: FormattedValue,
    doc2?: FormattedValue,
    mapper: (type: "doc1" | "doc2", d: DocObj) => DocObj = (_, x) => x,
): DocObj[] {
    return [
        !doc1 || typeof doc1 === "string" || typeof doc1 === "boolean"
            ? doc1
            : doc1.map(mapper.bind(null, "doc1")),
        !doc2 || typeof doc2 === "string" || typeof doc2 === "boolean"
            ? doc2
            : doc2.map(mapper.bind(null, "doc2")),
    ]
        .filter(
            (d: DocObj[] | string | boolean | undefined): d is DocObj[] =>
                typeof d !== "string" &&
                typeof d !== "boolean" &&
                typeof d !== "undefined",
        )
        .flat();
}
